export const parseErrors = (errors: { [key: string]: string[] }) => {
  return Object.entries(errors).reduce<{ [key: string]: string }>(
    (acc, [key, value]) => {
      acc[key] = value[0];
      return acc;
    },
    {},
  );
};
